import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { jobCategoryAutoCompleteInput$, jobCategoryAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const JobCategoryAutoSuggest = renderAutoSuggestWithOptions(
   jobCategoryAutoCompleteObservable$,
   jobCategoryAutoCompleteInput$,
);

JobCategoryAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: [],
   forceSelection: false,
   placeholder: 'Search Job Categories...',
};

export default JobCategoryAutoSuggest;
